/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';
import { SharedTrialOfferProps, TrialOffer } from '../TrialOffer';

/**
 * Offers the opportunity to start a Team trial.
 */
export const TeamTrialOffer = (props: SharedTrialOfferProps) => (
  <TrialOffer
    description="Bring your team together to collaborate on automation. With a Team account, each member can automate their own work or collaborate with each other."
    features={[
      { iconName: 'miscBolt', label: 'Unlimited Zaps' },
      { iconName: 'personGroup', label: 'Unlimited users' },
      { iconName: 'miscClock', label: 'Our fastest update times' },
      { iconName: 'miscHeadset', label: 'Dedicated Premier Support Team' },
    ]}
    fullStoryEventName="Viewed Team Trial Offer"
    title="Try Zapier For Teams"
    trialType="Team"
    {...props}
  />
);
